import { ITypedReduxAction } from 'shared/map-search/types/redux/actionType';

export enum ELayoutForMapActionTypes {
  PostReadyMessage = 'LAYOUT_FOR_MAP/POST_READY_MESSAGE',
}

export type TLayoutForMapPostReadyMessage = ITypedReduxAction<ELayoutForMapActionTypes.PostReadyMessage, void>;

export type TLayoutForMapActions = TLayoutForMapPostReadyMessage;
